import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TableModel } from 'src/app/models/table.model';
import { PagedOrderDetails } from 'src/app/buyer/models/paged.order.detail';
import { OrderCreateModel } from 'src/app/buyer/models/order.create.model';

@Injectable()
export class OrderService {

    constructor(private http: HttpClient) { }

    createFromCart(model: OrderCreateModel) {
        return this.http.post(`${environment.apiUrl}/api/user/order/create-from-cart`, model);
    }

    createFromImage(model: OrderCreateModel) {
        return this.http.post(`${environment.apiUrl}/api/user/order/create-from-image`, model);
    }

    list(tableModel: TableModel): Observable<PagedOrderDetails> {
        let url = `${environment.apiUrl}/api/user/order/list`;
        const queryParams = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<PagedOrderDetails>(url);
    }

    getOrderById(id: string) {
        return this.http.get(`${environment.apiUrl}/api/user/order/${id}`);
    }

    downloadFiles(orderId: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}/api/user/order/download-images/${orderId}`, { responseType: 'blob' });
    }

}
